import { memo } from "react";
import Button from "@mui/material/Button";
import styles from "./clear-cart-popup.module.scss";

export interface ClearCartPopupProps {
  handleClearCartPopupClose: () => void;
  handleClearCartPopupButtonClick: () => void;
}

const ClearCartPopup = memo(function ClearCartPopup({
  handleClearCartPopupClose,
  handleClearCartPopupButtonClick,
}: ClearCartPopupProps) {
  return (
    <div
      className={`absolute left-[-110px] bottom-[-134px] w-[323px] rounded-2xl bg-neutral-800 p-4 ${styles["clear-cart-popup"]}`}
    >
      <p className="w-56 text-sm text-white">
        Are you sure you want to clear cart? All items in the cart will be lost.
      </p>
      <div className="mt-4 flex">
        <Button
          id="cancel-cart-button"
          onClick={handleClearCartPopupClose}
          className="border-bg-neutral-800 mr-2 w-full rounded-lg border-1 border-solid border-neutral-800 py-[7px] px-6 text-sm font-normal normal-case text-white hover:border-1 hover:border-solid hover:border-white hover:bg-neutral-800"
          size="large"
        >
          Cancel
        </Button>
        <Button
          id="checkout-cart-button"
          className={`w-full rounded-lg bg-primary-300 py-[7px] px-6 text-sm font-medium normal-case text-white
                        hover:bg-primary-300`}
          size="large"
          onClick={handleClearCartPopupButtonClick}
        >
          Clear Cart
        </Button>
      </div>
    </div>
  );
});

export default ClearCartPopup;
